import axios from "axios";

export const state = {
    patientdebtors: [],
};

export const getters = {
    patientdebtors: state => state.patientdebtors,
};

export const mutations = {
    setDebtors(state, newValue) {
        state.patientdebtors = newValue
    },
};

export const actions = {
    fetchDebtors({ commit }) {
        axios.get('/patientdebtors').then(res => {
            commit('setDebtors', res.data.debts);
        })
    },
};
